// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29i0v","title":"styles_title__2ebEe"};